import { Logger } from '~~/helpers/logger';

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { getBreadcrumbsFromProduct } from '~~/helpers/category/getBreadcrumbsFromProduct';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';
import type { ProductProjection, ProductProjectionSearchResult } from '~~/types/commercetools';
import extendProducts from '~~/helpers/product/extendProducts';

export const useCartRecommendations = () => {

  const { languageAndCountry, countryCode } = useLocalization();
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const products = ref<ProductProjection[]>([]);

  const search = async (product: ProductVariantExtended) => {

    if (!product._breadcrumbs || !product._breadcrumbs[0]) {

      return;
    
    }

    const breadcrumbs = getBreadcrumbsFromProduct(product);
    const secondLevelCategoryId = breadcrumbs?.at(2)?.id || '';

    if (!secondLevelCategoryId) {

      return;

    }

    try {

      const response = await makeCommercetoolsRequest<{
        productProjectionSearch: ProductProjectionSearchResult;
      }>({
        endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_CART_RECOMMENDATIONS,
        data: [
          {
            queryFilters: [
              { string: `categories.id: subtree("${secondLevelCategoryId}")` },
              { string: 'variants.availability.isOnStock:true' },
              { string: `variants.attributes.eligibleForSelling.${languageAndCountry.value}:true` },
            ],
            limit: 10,
          },
        ],
      });

      products.value = (response?.data?.productProjectionSearch?.results || []).filter(
        (p) => p.id !== product._id,
      );
    
    } catch (err) {

      Logger.error('error.useCartRecommendations', String(err));
    
    }
  
  };

  const recommendedProducts = computed<ProductVariantExtended[]>(() =>
    extendProducts(products.value, languageAndCountry.value, countryCode.value, { isPublished: true, inStock: true }),
  );

  return {
    recommendedProducts,
    search,
  };

};
